module.exports = __webpack_public_path__ + "img/HOME_CLOCK_OUT.35bc31a9.svg";